import {createAction} from "redux-act";


export const clearHereNowReducer = createAction('clearHereNowReducer');

export const setUserAsPlaying = createAction<number>('setUserAsPlaying');
export const setPlayingContestUsersSuccess = createAction<number>('setPlayingContestUsersSuccess');

export const getPlayingUsers = createAction('getPlayingUsers');
export const getPlayingUsersSuccess = createAction<number>('getPlayingUsersSuccess');
